













import Vue from 'vue';
import Component from 'vue-class-component';
import ChevronDoubleRightIcon from 'vue-material-design-icons/ChevronDoubleRight.vue';


@Component({
    components: { ChevronDoubleRightIcon }
})
export default class DetalhesProsseguir extends Vue {

    get cotacao () {
        return this.$store.state.cotacao;
    }

    get email() {
        return this.$store.getters.get_email;
    }

    public onClick () {
        this.$router.push({
            name: 'finalizar'
        });

    }

}
